<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <template #end>
        <el-form-item v-show="[1, 2, 3, 4].includes(user.user_group_id)">
          <el-button type="success" @click="settle">批量结算</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showSelect="[1, 2, 3, 4].includes(user.user_group_id)" :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #open="params">
        <MySwitch v-if="[1, 2, 3, 4].includes(user.user_group_id)" :data="params.params" :activeValue="'2'" :inactiveValue="'1'" @onToggle="toggleDisplay"></MySwitch>
        <span v-else>{{ params.params.settled == 1 ? '未结算' : '已结算' }}</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'shipperrec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/shipper` },
        { name: "应收账款管理", path: `/finance/shipper` },
        { name: "运单列表" },
      ],
      formInline: {
        index: 3,
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        // {
        //   ...this.ctrls.date,
        //   label: "装货日期",
        //   keyName: "starttime",
        // },
        // {
        //   ...this.ctrls.date,
        //   label: "卸货日期",
        //   keyName: "edittime",
        // },
        // {
        //   label: "装货地址：",
        //   keyName: "coaddress",
        //   placeholder: "请填写装货地址",
        //   type: "text",
        // },
        // {
        //   label: "卸货地址：",
        //   keyName: "enaddress",
        //   placeholder: "请填写卸货地址",
        //   type: "text",
        // },
        // {
        //   label: "公司单价：",
        //   keyName: "cprice",
        //   placeholder: "请填写公司单价",
        //   type: "text",
        // },
        {
          ...this.ctrls.license,
          label: "车牌号",
        },
        {
          label: "结算状态",
          keyName: "settled",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '全部', value: '' },
            { label: '未结算', value: 1 },
            { label: '已结算', value: 2 },
          ],
        },
      ],
      searchDateOptions: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "predict_unloading_date", label: "卸货日期", },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", width: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", width: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', width: 110 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprices", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 110 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 110 },
        { keyName: "additional", label: "附加费用", align: 'right', className: 'pr30', width: 120 },
        { keyName: "compen", label: "补差金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "open", label: "结算状态", slot: "open" },
        { keyName: "repaytime", label: "预计结款日期", minwidth: 120 },

        // { keyName: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        // { keyName: "dfreight", label: "司机运费", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['inton', 'unton', "kuiton", "dtonprices", "additional", "infreight", "freight", 'compen'],
      baseParams: ['index', 'shipperid'],
    };
  },
  methods: {
    onSearchItemChange({ key }) {
      if (['fleet', 'settled'].includes(key)) {
        this.page = 1;
        this.getList()
      }
    },
    setFleet({ team }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'fleet') {
          c.options = [
            { label: '全部', value: '' },
          ]
          team.map(v => {
            c.options.push({
              label: v.nickname,
              value: v.id,
            })
          })
          // c.options.push({
          //   label: '雇佣运单',
          //   value: 10000,
          // })
        }
      })
      this.$forceUpdate()
    },
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.open = v.settled + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    settle() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '请选择条目!',
        });
        return
      }
      let count = 0
      const arr = []
      this.selection.map(v => {
        count += Number(v.freight) - Number(v.dtonprices) + Number(v.compen)
        arr.push(v.id)
      })
      // console.log(this.selection)
      this.$confirm(`结算金额为${count}元？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.settleReq(arr);
      }).catch(() => { });
    },
    settleReq(delList) {
      let url = `custom/settlement`;
      const params = {
        // userid: this.user.id,
        delList,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    toggleDisplay({ id }) {
      let url = `custom/upsettled`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getFleet()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.el-button--success {
  background-color: #13ce66;
  border-color: #13ce66;
}
</style>
